(function (angular) {
    angular.module('bizPartEngage').service('modules.certifications.service', certificationsService);

    certificationsService.$inject = ["$http"];

    function certificationsService($http) {

        var servicePath = siteRootPath + 'api/certificationsuser/';

        this.GetCertificationsForUser = function () {
            return $http.get(servicePath + 'GetCertificatesForUser');
        };        
    }
})(window.angular);